import { CLEAR_PAGE } from '../base/types';
import { FETCH_USERS } from './types';

const INIT_STATE = {
  isLoading: false,
  isLoaded: false,
  data: {}
};

const usersReducer = (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case `${FETCH_USERS}_PENDING`:
      return {
        ...state,
        isLoading: true,
      };
    case `${FETCH_USERS}_FULFILLED`:
      return {
        ...state,
        data: payload,
        isLoaded: true,
        isLoading: false,
      };
    case `${FETCH_USERS}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };

    case CLEAR_PAGE:
      return payload === 'users' ? INIT_STATE : state;

    default:
      return state;
  }
};

export default usersReducer;
